import _widgetContainer from "../../_js/cmp/widgetcontainer";
import _timelineStepper from "./cmp/timelinestepper";
import _trellisHeader from "./cmp/trellisheader";
import _timeline from "./cmp/timeline";
import _currentValue from "./cmp/currentvalue";
import _trellisMap from "./cmp/trellismap";
import _errormsg from "../../_js/cmp/errormsg";


export default function (widget) {
    const m = widget.m;
    const ns = widget.ns;
    const t = widget.txt;
    const state = widget.state;


    const widgetContainer = _widgetContainer(widget);
    const timelineStepper = _timelineStepper(widget);
    const trellisHeader = _trellisHeader(widget);
    const timeline = _timeline(widget);
    const currentValue = _currentValue(widget);
    const trellisMap = _trellisMap(widget);
    const errormsg = _errormsg(widget);

    const widgetComponent = {

        // controller: function() {
        //   const ctrl = this;
        // },


        view: function (/*ctrl*/) {

            const widgetCatastrophe = state.catastrophe.widgetdata;
            if (widgetCatastrophe && !state.forecastData) {
                return (
                    m('div', {
                            className: ns + ' ' + ns + '--error',
                        },
                        m(errormsg, {
                            error: widgetCatastrophe,
                        })
                    )
                );
            }

            if (!state.forecasts || !widget.cssLink.isLoaded || !t.isReady) {
                return (
                    m('div', {
                            className: ns + ' ' + ns + '--loading',
                            'aria-busy': true,
                        },
                        m('p', {
                                className: ns + '__loadingmsg',
                                lang: 'en',
                            },
                            'Loading...'
                        )
                    )
                );
            }

            const forecastLoadingClass = !state.forecastData ? ns + '--forecastloading' : '';
            return (
                m(widgetContainer, {
                        className: ns + forecastLoadingClass,
                    },

                    m(trellisHeader),
                    m(trellisMap),
                    m('div', {className: ns + '__navigation'},
                        state.forecastData ?
                            [
                                m(currentValue),
                                m(timelineStepper),
                                m(timeline, {key: 123})
                            ] :
                            [' ', ' ', ' ']
                    )
                )
            );
        },
    };

    return widgetComponent;
};
